import { FC } from 'react';

const CloseIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 8"
      width="8"
      height="8"
      fill="none"
      className={className}
    >
      <path
        d="M7 1L1 7M1 1L7 7"
        stroke="#505050"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseIcon;
